/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, Typography2 } from '@coursera/cds-core';

import { CoachBrandLabel } from 'bundles/ai-course-coach/assets/coachBranding';
import { TagBeta } from 'bundles/ai-course-coach/components/common';

import _t from 'i18n!nls/academic-integrity';

const styles = {
  chatHeader: css`
    padding-top: var(--cds-spacing-300);
    padding-right: var(--cds-spacing-400);
    padding-left: var(--cds-spacing-400);
    padding-bottom: var(--cds-spacing-200);
    height: var(--cds-spacing-800);
    align-items: center;
  `,
  chatTitle: css`
    margin-right: var(--cds-spacing-200);
  `,

  iconContainer: css`
    display: flex;
    align-items: center;
  `,
  coachIcon: css`
    margin: 0 var(--cds-spacing-100) 0 0;
  `,
};

const IntegrityCheckChatHeader = () => (
  <Grid container className="integrity-check-chat-header" justifyContent="space-between" css={styles.chatHeader}>
    <Typography2 variant="subtitleLarge" component="div" css={styles.chatTitle}>
      {_t('Integrity Check')}
    </Typography2>
    <Grid item css={styles.iconContainer}>
      <CoachBrandLabel css={styles.coachIcon} />
      <TagBeta />
    </Grid>
  </Grid>
);

export default IntegrityCheckChatHeader;
